import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/initI18n';
import App from './App';
import { bootstrapAuthFromUrl } from './auth/cascadeAuth';

bootstrapAuthFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
